import { DataStory } from '../../features/FunctionalDesignXPLR/FunctionalRequirements/interfaces';

export const functionalRequirementsDefaultData: DataStory[] = [
  {
    title: 'User Stories',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'UX/UI Requirements',
    required: false,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Business Rules',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Outputs and Reports',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
];
export const noFunctionalRequirementsDefaultData = [
  {
    title: 'Current Technology Stack',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Data Security',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Network and Infrastructure',
    required: false,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Usage Requirements',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
];
export const pocRequirementsDefaultData = [
  {
    title: 'POC Scope Of Work',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'PoC Data Requirements',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Deliverables',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Acceptance Criteria',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
];
export const integratedRequirementsDefaultData = [
  {
    title: 'Statement of Work',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Deliverables',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
  {
    title: 'Acceptance Criteria',
    required: true,
    editable: false,
    items: [
      {
        title: '',
        text: '',
        disabled: false,
      },
    ],
  },
];

export const pocStatusFieldDefaultData = {
  deploymentHandshake: false,
  effortAndCostEstimation: false,
  functionalRequirements: false,
  generalInformation: false,
  inputsDataSource: false,
  integratedRequirements: false,
  noFunctionalRequirements: false,
  pocRequirements: false,
};
